import { collection, onSnapshot, getDocs } from "firebase/firestore";
import { db } from "@/fb.js";

export default {
  state: {
    ships: {
      items: [],
      current_ship: {},
      current_configuration: {},
      current_modification: {},
    },
  },

  getters: {
    ships_items(state) {
      return state.ships.items;
    },
    currentShip(state) {
      return state.ships.current_ship;
    },
    currentConfiguration(state) {
      return state.ships.current_configuration;
    },
    currentModification(state){
      return state.ships.current_modification;
    }
  },

  mutations: {
    SET_SHIPS_ITEMS(state, value) {
      state.ships.items = value;
      //console.log("items ships: ", value);
    },
    SET_SHIPS_CURRENT_SHIP(state, value) {
      state.ships.current_ship = value;
      //console.log("current ship: ", value);
    },
    SET_SHIPS_CURRENT_CONFIGURATION(state, value) {
      state.ships.current_configuration = value;
      //console.log("current configuration: ", value);
    },
    SET_SHIPS_CURRENT_MODIFICATION(state, value) {
      state.ships.current_modification = value;
      //console.log("current modification: ", value);
    },
    
  },

  actions: {
    async shipsOnSnapShot({ commit }) {
      let ships = [];
      onSnapshot(collection(db, "Ships"), (querySnapshot) => {
        const changes = querySnapshot.docChanges();

        changes.forEach(async (change) => {
          if (change.type === "added") {
            //console.log("New Ship id: ", change.doc.id);
            //console.log("New Ship: ", change.doc.data());
            const ship = await getConfigurations({
              id: change.doc.id,
              values: change.doc.data(),
            });
            ships.push(ship);
          }
          if (change.type === "modified") {
            const pos = ships.map((val) => val.id).indexOf(change.doc.id);
            ships[pos] = {
              ...change.doc.data(),
              id: change.doc.id,
            };
            //console.log("Modified Ship: ", change.doc.data());
          }
          if (change.type === "removed") {
            const pos = ships.map((val) => val.id).indexOf(change.doc.id);
            if (pos >= 0) {
              ships.splice(pos, 1);
              //console.log("Removed Ship: ", change.doc.data());
            }
          }
          commit("SET_SHIPS_ITEMS", ships);
        });
      });
    },
    formatShips({ state }) {
      const json = state.ships.items;
      let fjson = {};

      json.map((ship) => {
        fjson[ship.id] = ship;

        //console.log(fjson[ship.id]);
      });
    },
  },
};

///////////////////////

async function getConfigurations(data) {
  var ship = {};

  const configurations = await getDocs(
    collection(db, "Ships", data.id, "ShipConfigurations")
  );
  const modifications = await getDocs(
    collection(db, "Ships", data.id, "ShipModifications")
  );

  configurations.forEach(async (doc2) => {
    let config = {};
    ship = {
      id: data.id,
      name: data.values.name,
      data: data.values,
    };
    //console.log(doc2);

    let dataConfig = [];
    let array_configuraciones_ship = [];
    doc2.data().Configurations.forEach(async (ele) => {
      config["name"] = doc2.data().name;
      config["description"] = doc2.data().description;
      config["configurations_array"] = doc2.data().Configurations;
      config["id"] = doc2.id;
      config["id_buque"] = data.id;

      const config_ex = await getDocs(
        collection(db, "Ships", data.id, "ShipConfigurations", doc2.id, ele)
      );

      config_ex.forEach(async (doc3) => {
        dataConfig.push({
          id: doc3.id,
          name: ele,
          description: doc3.description,
          data: doc3.data(),
        });

        //console.log(doc3.id, " => ", doc3.data());
        //console.log(dataConfig);
      });
      config["data"] = dataConfig;
    });
    array_configuraciones_ship.push(config);
    ship["configurations"] = array_configuraciones_ship;
  });

  modifications.forEach(async (doc2) => {
    let modif = {};
    ship = {
      id: data.id,
      name: data.values.name,
      data: data.values,
    };
    //console.log(doc2);

    let dataModif = [];
    let array_modificaciones_ship = [];

    doc2.data().Modifications.forEach(async (ele) => {

      modif["name"] = doc2.data().name;
      modif["description"] = doc2.data().description;
      modif["modifications_array"] = doc2.data().Modifications;
      modif["id"] = doc2.id;
      modif["id_buque"] = data.id;

      const modif_ex = await getDocs(
        collection(db, "Ships", data.id, "ShipModifications", doc2.id, ele)
      );

      modif_ex.forEach(async (doc3) => {

        dataModif.push({
          id: doc3.id,
          name: ele,
          description: doc3.description,
          data: doc3.data(),
        });

        //console.log(doc3.id, " => ", doc3.data());
        //console.log(dataModif);
      });
      modif["data"] = dataModif;
    });
    array_modificaciones_ship.push(modif);
    ship["modifications"] = array_modificaciones_ship;
  });

  //console.log(ship);

  return ship;
}
